__turbopack_context__.v({
  "active": "icon-button-module__5gh_MG__active",
  "badge": "icon-button-module__5gh_MG__badge",
  "iconBtn": "icon-button-module__5gh_MG__iconBtn",
  "overlay": "icon-button-module__5gh_MG__overlay",
  "surface": "icon-button-module__5gh_MG__surface",
});
